<template>
<div  class="">
        <!-- upload photo -->
        <div v-if="modal_create" class="modal" >
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Sube una nueva imagen</h5>
                    <button @click="toggle_modal_create" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <preview-component  :url="url" :user_id="user_id" @escucharHijo="VariableHijo_one"></preview-component>
                </div>
                <div class="modal-footer">
                    <button @click="toggle_modal_create" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>

        
        <div v-if="modal" class="modal" id="myModal_album_one" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Selecciona una foto</h4>
                        <button @click="toggle_modal" type="button" class="btn-close"></button>
                                
                        
                    </div>
                    <div class="modal-body example-3">
                        <h3>Seleccionar una foto</h3>
                        <ul class="list-unstyled">
                            <li style="position: relative" v-for="photo in vue_photos_one" :key="photo.id">
                                <input @click="llenar_photo(photo.id)" class="radio" type="radio" :id="('radio'+photo.id)" :value="photo.id" v-model="radios">
                                <label class="label" :for="('radio'+photo.id)">
                                    <img :src="get_month_day(photo.created_at)+photo.name+'-150.'+photo.extension" :alt="photo.alt">
                                </label>
                                <p style="position: absolute;bottom: -10px;left: 14px;">{{photo.name.slice(0,10)}}</p>
                                
                            </li>
                        </ul>
                    </div>
                    <nav class="d-flex justify-content-center" aria-label="...">
                        <ul class="pagination">
                            <li class="page-item" :disabled="(current_page <= 1) ? '':'disabled'" @click="getPhotos_one(current_page-1)">
                                <a class="page-link" tabindex="-1">Previous</a>
                            </li>
                            <!--<li class="page-item"><a class="page-link" href="#">1</a></li>
                            <li class="page-item active">
                                <a class="page-link" href="#">2 <span class="sr-only">(current)</span></a>
                            </li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>-->
                            <li class="page-item">
                                <a class="page-link" @click="getPhotos_one(current_page+1)">Next</a>
                            </li>
                        </ul>
                    </nav>
                    <div class="modal-footer">
                        <button @click="toggle_modal"  type="button" class="btn btn-success">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="form-group">
                    <input required id="photo" name="photo" type="hidden" class="form-control " :value="radios">
                </div>
                <div class="example-3">
                    <h3>Foto Principal</h3>
                    <ul>
                        <li>
                        <span v-if="radios === 0">
                            <img class="img-selected" :src="require('../../../assets/subir.png')">
                        </span>
                        <span v-else v-for="photo in vue_photos_one" :key="photo.id">
                            <img class="img-selected" 
                            v-if="radios == photo.id" 
                            :src="get_month_day(photo.created_at)+photo.name+'-150.'+photo.extension" 
                            :alt="photo.alt">
                        </span>
                        </li>
                    </ul>

                    <a @click="toggle_modal" class="btn btn-sm btn-primary text-white" type="button" data-toggle="modal" data-target="#myModal_album_one">
                        mas imagenes
                    </a>
                    <button @click="toggle_modal_create" class="btn btn-sm  btn-success mx-2">
                        Subir foto
                    </button>
                    <br>
                    <span>Seleccionados Para galeria: {{ radios }} --{{v_photo}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import {ref,onMounted, computed} from 'vue'
import axios from "axios";
import previewComponent from "./previewComponent.vue";

export default{
    props: ['photolaravel','user_id','url'],
    components:{
        'preview-component':previewComponent,
    },
    setup(props){
        const toast = useToast()
        const store = useStore()

        const v_photo = computed(()=>store.state.v_photo)
        const modal = ref(false)
        const modal_create = ref(false)
        const vue_photos_one = ref([])
        const new_photo_one = ref([])
        const current_page = ref(null)
        const radios = ref(0)
        const photo_default = require('../../../assets/subir.png');
        
        const toggle_modal = () =>{
            modal.value = ! modal.value
            getPhotos_one()
        }
        const toggle_modal_create = () => {
            modal_create.value = !modal_create.value
            getPhotos_one()
        }
        const get_month_day = (created_at) =>{

            let d = new Date(created_at).getDate();
            let m = new Date(created_at).getMonth();
            let y = new Date(created_at).getFullYear();
            m = (parseInt(m)+1);
            m = m.toString().padStart(2,0);
            console.log('/upload/'+y+'/'+d+'/'+m+'/='+created_at);
            return props.url+'/upload/'+y+'/'+m+'/';
        }
        const getPhotos_one = (page) => {
            if(!page>0){
                current_page.value = 0;
                page = 0;
            }
            let urlPhotos = props.url+'/api/my-photos'+'?page='+page;
            axios.get(urlPhotos,{
                params: {
                    id_user:props.user_id
                }
            }).then(response => {
                vue_photos_one.value = response.data.photos.data;
                current_page.value = response.data.pagination.current_page;
            });
        }
        const createPhoto = () => {
            let url = props.url+'/api/save-photo';
            axios.post(url , {
                name: new_photo_one.value,
                id_user:props.user_id
            }).then(response => {
                getPhotos_one();
                new_photo_one.value = [];
                toast.success('subido'+response)
            }).catch(error =>{
                toast.error('error'+error);
            });
        }
        const VariableHijo_one = ()=>{
            getPhotos_one();
        }
        const cargarImagenes_one = ()=>{//cargar imagenes
       
        if (props.photolaravel){//  si hay  datos
                radios.value = props.photolaravel.id;
                llenar_photo(props.photolaravel.id)//vuex
            }else{
                console.log('no hay photo')
                store.state.v_photo = 0
            }
            
        }
        const seleccionarUnaImagen = ()=> {
            console.log(this.radios)
        }
        const llenar_photo = (id)=>{
            store.state.v_photo = id
        }

        onMounted(()=>{
            
            console.log('montando.....')
            getPhotos_one()
            cargarImagenes_one()
        })


    return{
        toggle_modal_create,
        llenar_photo,
        modal,
        modal_create,
        toggle_modal,
        seleccionarUnaImagen,
        cargarImagenes_one,
        VariableHijo_one,
        createPhoto,
        getPhotos_one,
        get_month_day,
        vue_photos_one,
        new_photo_one,
        current_page,
        radios,
        photo_default,
        v_photo,

    }
    }
}


</script>